module.exports = __webpack_public_path__ + "media/images/logos/02-6a2128a9358ea370fda16d771b9dbb60.png";